import type { FC } from 'react';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import { Box, Container, Divider, Tab, Tabs, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const tabs = [
  {
    href: '/project',
    label: 'general'
  },
  {
    href: '/project/team',
    label: 'people'
  },
  // {
  //   href: '/project/billing',
  //   label: 'Billing'
  // }
];

export const Project: FC = () => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        flexGrow: 1
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <Box sx={{ py: 5 }}>
          <Box
            sx={{
              alignItems: 'flex-start',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Typography
              color="textPrimary"
              variant="h2"
            >
              {t('project_settings')}
            </Typography>
            <Typography
              color="textSecondary"
              variant="body2"
              sx={{ mt: 0.5, maxWidth: '64ch' }}
            >
              Configure your project details, team and validators.
            </Typography>
          </Box>
          <Tabs
            allowScrollButtonsMobile
            sx={{ mt: 2 }}
            value={tabs.findIndex((tab) => tab.href === location.pathname)}
            variant="scrollable"
          >
            {tabs.map((option) => (
              <Tab
                component={RouterLink}
                key={option.href}
                label={t(option.label)}
                to={option.href}
              />
            ))}
          </Tabs>
          <Divider />
        </Box>
        <Outlet />
      </Container>
    </Box>
  );
};
